import React from 'react'

const RoundButtonText = ({ text }) => {
  const { textStyle } = styles
  return <p style={textStyle}>{text}</p>
}

const styles = {
  textStyle: {
    fontSize: 28,
    textAlign: 'center',
    backgroundColor: 'transparent',
    color: 'white'
  }
}

export { RoundButtonText }



// WEBPACK FOOTER //
// ./src/components/common/RoundButtonText.js